import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { firstValueFrom } from "rxjs";

import { ListResult } from "../models/list-result.model";
import { Product } from "../models/product.model";
import { ProductArea } from "../models/product-area.model";
import { AuthService } from "./auth.service";

@Injectable({
  providedIn: "root",
})
export class ProductsService {
  constructor(
    @Inject("BASE_URL") private baseUrl: string,
    private http: HttpClient,
    private authService: AuthService,
    private translateService: TranslateService,
  ) {}

  private async getDefaultHeaders(): Promise<{ [header: string]: string }> {
    return {
      Authorization: this.authService.getAuthorizationHeaderValue(),
      "Accept-Language": this.translateService.currentLang,
    };
  }

  async getMyProductAreas(): Promise<ProductArea[]> {
    const options = { headers: await this.getDefaultHeaders() };
    const result = await firstValueFrom(
      this.http.get<ListResult<ProductArea>>(
        this.baseUrl + `api/v1/me/productAreas`,
        options,
      ),
    );
    const items = result?.items || [];
    return items.sort((p1, p2) => (p1.name > p2.name ? 1 : -1));
  }

  async searchProducts(
    productArea: string,
    serialNo: string,
  ): Promise<Product[]> {
    const options = {
      headers: await this.getDefaultHeaders(),
      params: new HttpParams()
        .set("search", serialNo),
    };
    const result = await firstValueFrom(
      this.http.get<ListResult<Product>>(
        this.baseUrl + `api/v1/products/${productArea}`,
        options,
      ),
    );
    return result?.items || [];
  }
}
